import { render, staticRenderFns } from "./AuthentificationForm.vue?vue&type=template&id=226fa3f5&scoped=true"
import script from "./AuthentificationForm.vue?vue&type=script&lang=js"
export * from "./AuthentificationForm.vue?vue&type=script&lang=js"
import style0 from "./AuthentificationForm.vue?vue&type=style&index=0&id=226fa3f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226fa3f5",
  null
  
)

export default component.exports